import { createSvgIcon } from '../../createSvgIcon';

export const ConsentIcon = createSvgIcon(
  <path
    d="M0.888889 0H15.1111C15.3469 0 15.573 0.0936505 15.7397 0.260349C15.9064 0.427048 16 0.653141 16 0.888889V15.1111C16 15.3469 15.9064 15.573 15.7397 15.7397C15.573 15.9064 15.3469 16 15.1111 16H0.888889C0.653141 16 0.427048 15.9064 0.260349 15.7397C0.0936505 15.573 0 15.3469 0 15.1111V0.888889C0 0.653141 0.0936505 0.427048 0.260349 0.260349C0.427048 0.0936505 0.653141 0 0.888889 0ZM1.77778 1.77778V14.2222H14.2222V1.77778H1.77778ZM7.11378 11.5556L3.34222 7.784L4.59911 6.52711L7.11378 9.04178L12.1422 4.01333L13.3991 5.27022L7.11378 11.5556Z"
    fill="currentColor"
  />,
  { displayName: 'ConsentIcon', viewBox: '0 0 16 16' }
);
